import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useUserId, useUserRole } from "../../util_functions/helpers";
import VideoCallPage from "./VideoCallPage";

const MeetingOptions = () => {
  const { preferredMethod, sessionName, threadId } = useParams();
const userRole = useUserRole();
  const userId   = useUserId();
  const userName = userRole === "worker" ? "worker" : "client";
  console.log("MeetingOptions Preferred Method:", preferredMethod);
  console.log("MeetingOptions sessionName:", sessionName);
  console.log("MeetingOptions userId:", userId);
  console.log("MeetingOptions userName:", userName);
  console.log("MeetingOptions userRole:", userRole);
  const navigate = useNavigate();

  if (!preferredMethod || !sessionName || !threadId || !userId || !userName) {
    console.error("Missing required route params");
    const dashboardPath =
        userRole === "worker" ? "ps-dashboard" : "fs-dashboard";
    navigate(`/account/${dashboardPath}/inbox`, { replace: true });
    return null;
  }

  return (
    <div>
      <VideoCallPage
        appId="3b25cc99bc684ef09c4efe171ad01cfe"
        channelName="test"
        sessionName={sessionName}
        token={null}
        userId={userId}
        userName={userName}
        userRole={userRole}
        threadId={threadId}
      />
    </div>
  );
};

export default MeetingOptions;
